import OptOutForm from "../components/OptOutForm"
import "./home.scss"

const Home = () => {
    
    return (
        <div className="home">
            
            <OptOutForm />
    
        </div>
    )
}

export default Home